// src/components/Activation.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Activation.css';

const Activation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('activating');
  const [message, setMessage] = useState('Activation en cours...');

  useEffect(() => {
    const activateAccount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/activate/${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Compte activé avec succès !');
        
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Erreur lors de l\'activation');
      }
    };

    activateAccount();
  }, [token, navigate]);

  return (
    <div className="activation-page">
      <div className="activation-container">
        {status === 'activating' && (
          <div className="loading-spinner"></div>
        )}
        
        {status === 'success' && (
          <div className="activation-success">
            <div className="checkmark">✓</div>
            <h2>Compte activé !</h2>
            <p>{message}</p>
            <p>Redirection vers la page de connexion...</p>
          </div>
        )}
        
        {status === 'error' && (
          <div className="activation-error">
            <div className="error-icon">✕</div>
            <h2>Activation échouée</h2>
            <p>{message}</p>
            <button onClick={() => navigate('/')}>Retour à la connexion</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Activation;


